import styles from './carousel-skeleton.module.css'

import cn from 'clsx'
import type { ComponentType } from 'react'
import React from 'react'

import { Flex } from 'components/ds'

type SkeletonProps = {
  className?: string
}

export const Skeleton = ({ className }: SkeletonProps): React.ReactNode => (
  <div className={cn(styles.skeleton, className)} />
)

type CarouselSkeletonProps = {
  itemCount: number
  ItemSkeleton: ComponentType
  className?: string
}

export const CarouselSkeleton = ({
  itemCount,
  ItemSkeleton,
  className,
}: CarouselSkeletonProps): React.ReactNode => (
  <div className={cn(styles.container, className)}>
    <Flex gap="3" className={styles.itemsContainer}>
      {Array.from({ length: itemCount }).map((_, idx) => (
        <div key={idx} className={styles.item}>
          <ItemSkeleton />
        </div>
      ))}
    </Flex>
  </div>
)

export const CuratedPlaylistCardSkeleton = (): React.ReactNode => (
  <div className={styles.curatedPlaylistCard}>
    <Skeleton className={styles.curatedPlaylistImage} />
    <Flex direction="column" gap="2" className={styles.curatedPlaylistInfo}>
      <Skeleton className={styles.curatedPlaylistDate} />
      <Skeleton className={styles.curatedPlaylistTitle} />
      <Skeleton className={styles.curatedPlaylistSubtitle} />
    </Flex>
  </div>
)
